module.exports = __webpack_public_path__ + "static/media/proxxmu-wireframes.4bda2fe1.png";